import React, { useEffect } from "react";
import { getCurrentUser } from "@aws-amplify/auth";
import { useSessionStorage } from "usehooks-ts";
import { useNavigate } from "react-router-dom";
import { redirectToLogin } from "../util/functions";
import { useDispatch, useSelector } from "react-redux";
import { selectUser, userActions } from "../app/reducers/UserSlice";
import { useTheme } from "styled-components";
import { SpinnerCircular } from "spinners-react";
const AdminRoute = ({ element }) => {
  const navigate = useNavigate();
  const [isCognitoAuthed, setIsCognitoAuthed] = useSessionStorage(
    "isAuthed",
    null,
  );
  const dispatch = useDispatch();
  const currentUser = useSelector(selectUser);
  const [isAdmin, setIsAdmin] = useSessionStorage("isAdmin", null);
  const theme = useTheme();
  useEffect(() => {
    const isAuthed = async () => {
      try {
        await getCurrentUser();
        dispatch(userActions.principal());
        return true;
      } catch (error) {
        console.log(error);
        return false;
      }
    };
    isAuthed().then((res) => {
      setIsCognitoAuthed(res);
      if (!res) {
        redirectToLogin({ from: new URL(window.location.href), navigate });
      }
    });
  }, [setIsCognitoAuthed, navigate]);

  useEffect(() => {
    if (currentUser && currentUser.roleID === 2) {
      setIsAdmin(true);
    }
  }, [currentUser]);

  if (isCognitoAuthed === null || currentUser === null || isAdmin === null) {
    // still loading state → show spinner
    return (
      <div
        style={{
          display: "flex",
          minHeight: "100vh",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <SpinnerCircular
          size={48}
          thickness={200}
          speed={100}
          color={`rgba(${theme.colors.neutral200}, 1)`}
          secondaryColor={`rgba(${theme.colors.neutral100}, 1)`}
        />
      </div>
    );
  }

  if (currentUser && isCognitoAuthed && isAdmin) {
    return <>{element}</>;
  }

  if (currentUser && isCognitoAuthed && !isAdmin) {
    navigate("/submissions");
  }

  return (
    <div
      style={{
        display: "flex",
        minHeight: "100vh",
        alignItems: "center",
        justifyContent: "center",
        margin: "auto",
      }}
    >
      <SpinnerCircular
        size={48}
        thickness={200}
        speed={100}
        color={`rgba(${theme.colors.neutral200}, 1)`}
        secondaryColor={`rgba(${theme.colors.neutral100}, 1)`}
        style={{
          justifySelf: "center",
          position: "relative",
        }}
      />
    </div>
  );
};

export default AdminRoute;
